module.exports = __webpack_public_path__ + "resources/images/vakantie-297c7ff6be5c890ce026cbe11da8fc3b-cache.png";